import { render, staticRenderFns } from "./TicketCardActions.vue?vue&type=template&id=5d833be8&"
import script from "./TicketCardActions.vue?vue&type=script&lang=js&"
export * from "./TicketCardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports